// extracted by mini-css-extract-plugin
module.exports = {"MainImage":"MainImage-module--MainImage--3_ec8","SideNav":"MainImage-module--SideNav--YV4OI","Img":"MainImage-module--Img--1NACA"};